import { createContext } from 'react';
import type {
  SelectMember,
  SelectRole,
} from '@/components/PeopleRoleSelect/SelectRoleOrMemberModal/types';

export const PeopleRoleSelectContext = createContext<{
  memberNodes: SelectMember[];
  groupNodes: SelectRole[];
  selectHeight?: number;
  changeNodes: (type: 'member' | 'groups', data: (SelectMember | SelectRole)[]) => void;
  mode: 'select' | 'modal';
}>({
  changeNodes: () => {},
  memberNodes: [],
  groupNodes: [],
  mode: 'select',
});
